document.addEventListener('DOMContentLoaded', function () {

  const sections = document.querySelectorAll(
    '[id^="shopify-section-template--"]'
  );

  const counters = {};

  function addUniqueClass(section, baseClass) {
    counters[baseClass] = (counters[baseClass] || 0) + 1;

    // Common class
    section.classList.add(baseClass);

    // Unique class
    section.classList.add(
      baseClass + '_' + counters[baseClass]
    );
  }

  sections.forEach(function (section) {
    const id = section.id;

    /* MAIN PRODUCT */
    if (id.includes('__main')) {
      addUniqueClass(section, 'pdp_uni_main');
    }

    /* IMAGE WITH TEXT OVERLAY */
    else if (id.includes('__image_with_text_overlay')) {
      addUniqueClass(section, 'pdp_uni_image_overlay');
    }

    /* CUSTOM LIQUID */
    else if (id.includes('__custom_liquid')) {
      addUniqueClass(section, 'pdp_uni_custom_liquid');
    }

    /* CUSTOM HTML */
    else if (id.includes('__custom_html')) {
      addUniqueClass(section, 'pdp_uni_custom_html');
    }

    /* FEATURED PRODUCTS */
    else if (id.includes('__featured_products')) {
      addUniqueClass(section, 'pdp_uni_featured_products');
    }

    /* HIGHLIGHTS */
    else if (
      id.includes('__custom_highlights') ||
      id.includes('__highlights')
    ) {
      addUniqueClass(section, 'pdp_uni_highlights');
    }

    /* RICH TEXT */
    else if (id.includes('__rich_text')) {
      addUniqueClass(section, 'pdp_uni_rich_text');
    }

    /* ONE IMAGE */
    else if (id.includes('__mi_one_img')) {
      addUniqueClass(section, 'pdp_uni_one_img');
    }

    /* ONE FEATURE */
    else if (id.includes('__mi_one_feature')) {
      addUniqueClass(section, 'pdp_uni_one_feature');
    }

    /* FEATURE */
    else if (id.includes('__mi_feature')) {
      addUniqueClass(section, 'pdp_uni_feature');
    }

    /* CUSTOM TABLE */
    else if (id.includes('__custom_table')) {
      addUniqueClass(section, 'pdp_uni_custom_table');
    }

    /* FAQ */
    else if (id.includes('__faq')) {
      addUniqueClass(section, 'pdp_uni_faq');
    }

  });

});